/**
 * Shared constants for the real-time price cache (spec: T006)
 *
 * Freshness / retention
 * ---------------------
 * FRESHNESS_THRESHOLD_MS   – how long after the last update a price is "fresh"
 * STALE_PRICE_MAX_AGE_MS   – absolute ceiling before we stop showing the value
 * MAX_RETAINED_ENTRIES     – hard LRU cap for the retained registry
 * LRU_EVICTION_COUNT       – how many entries to evict in one pass
 *
 * Load validation
 * ---------------
 * LOAD_VALIDATION_TIERS    – allowed symbolCount values for validation runs
 */

/** ms after which a retained entry transitions fresh → stale */
export const FRESHNESS_THRESHOLD_MS = 15_000

/** ms after which a stale entry is too old to show (should be recovered or evicted) */
export const STALE_PRICE_MAX_AGE_MS = 60_000

/** Maximum entries in the retained registry before LRU eviction kicks in */
export const MAX_RETAINED_ENTRIES = 500

/** Number of LRU entries evicted per eviction pass */
export const LRU_EVICTION_COUNT = 50

/** Minimum ms between duplicate subscribe/unsubscribe calls (demand debounce) */
export const DEMAND_DEBOUNCE_MS = 50

/** Max recovery attempts before an entry is considered unrecoverable */
export const MAX_RECOVERY_ATTEMPTS = 3

/** Allowed symbol counts for load-validation runs */
export const LOAD_VALIDATION_TIERS = [50, 100, 500] as const

/** Target price-continuity rate (95%) from spec SC-002 */
export const PRICE_CONTINUITY_TARGET_RATE = 0.95

/** Target stale-recovery rate (95% within 5 s) from spec SC-004 */
export const STALE_RECOVERY_TARGET_RATE = 0.95

/** Stale recovery window in ms (5 s from spec SC-004) */
export const STALE_RECOVERY_WINDOW_MS = 5_000
